/**
 * No-op on web — Datadog tracks views automatically.
 */
export function trackDatadogView(_viewKey: string, _pathname: string) {}

/**
 * No-op on web — Datadog tracks views automatically.
 */
export function stopDatadogView(_viewKey: string) {}
